import { useState, useEffect } from 'react'
import Login from './pages/Login'
import CallerDashboard from './pages/CallerDashboard'
import SupportDashboard from './pages/SupportDashboard'
import TutorsListPage from './pages/TutorsListPage'

export default function App() {
  const [role, setRole] = useState(localStorage.getItem('role'))
  const handleLogin = (r) => setRole(r)
  const handleLogout = () => { localStorage.clear(); setRole(null) }

  // Кабинет директора живёт отдельной страницей /rop (web/rop.html, не React) —
  // раньше вход director/dir123 здесь показывал пустую заглушку «Директор·Выйти»
  // (Антон 13.08: «почини, чтобы было всё на crm.ctg.school» — он не должен
  // знать про отдельный /rop и логиниться туда second раз). У rop.html СВОИ имена
  // ключей localStorage (crm_token/crm_name/crm_role, не token/role/name) —
  // копируем токен в её формат и переходим, чтобы вход был один.
  useEffect(() => {
    // руководитель отдела продаж работает в том же кабинете, что директор,
    // и тоже не должен логиниться второй раз (01.11.2026)
    if (role !== 'director' && role !== 'sales_head') return
    localStorage.setItem('crm_token', localStorage.getItem('token') || '')
    localStorage.setItem('crm_name', localStorage.getItem('name') || '')
    localStorage.setItem('crm_role', role)
    window.location.replace('/rop')
  }, [role])

  if (role === null) return <Login onLogin={handleLogin} />
  if (role === 'director' || role === 'sales_head') return null // редирект в useEffect выше
  // Отдельная страница «Преподаватели» (список Лидеры / Новые / Остальные) — для всех менеджеров
  if (window.location.pathname === '/teachers' && ['caller', 'support', 'writer', 'tutor_manager'].includes(role)) return <TutorsListPage />
  if (role === 'caller') return <CallerDashboard onLogout={handleLogout} />
  if (role === 'support') return <SupportDashboard onLogout={handleLogout} />
  // Переписчик = чаты сопроводителя + сделка звонильщицы (Антон 07.09); старый WriterDashboard (Instagram) не используется
  if (role === 'writer') return <SupportDashboard onLogout={handleLogout} mode="writer" />
  // Менеджер по преподавателям (Антон 16–21.10): кабинет «Преподаватели» — Созвоны + Чаты; Анкеты и Задачи добавим следующими этапами
  if (role === 'tutor_manager') return <SupportDashboard onLogout={handleLogout} mode="tutors" />
}